import { useState as u, useCallback as f, useEffect as R, useMemo as b } from "react";
const m = new DOMRectReadOnly(0, 0, 0, 0);
function O(n, e) {
  let t = null;
  return (...o) => {
    t && clearTimeout(t), t = setTimeout(() => n(...o), e);
  };
}
function C(n = 300) {
  const [e, t] = u(null), o = f((c) => {
    t(c);
  }, []), [r, l] = u(m);
  return R(() => {
    const c = O((i) => {
      for (const a of i)
        l(a.target.getBoundingClientRect());
    }, n), s = new ResizeObserver(c);
    return e instanceof HTMLElement && s.observe(e), function() {
      s.disconnect();
    };
  }, [e, n]), b(() => ({ containerRef: o, contentRect: r }), [o, r]);
}
export {
  C as useResizeObserver
};
